import { isEqualTime } from "@suse-o11y/date-time";
import type { Time } from "@suse-o11y/date-time/time";
import { z } from "zod";

import type { TimeRange } from "../app/state/view/timeline/TimeRange";

import type { QueryKey } from "./react-query";

export const unmatched = z.unknown().optional();

export interface MatchQueryKeyParams {
	namespace?: z.ZodType;
	timestamp?: Time;
	timeRange?: TimeRange;
}

export function matchQueryKey(
	{ namespace, timestamp, timeRange }: MatchQueryKeyParams,
	...fragments: ReadonlyArray<z.ZodType>
) {
	const metaMatcher = z.object({
		namespace: namespace ?? unmatched,
		timestamp: timestamp == null ? unmatched : z.number().refine((value) => isEqualTime(value, timestamp)),
		timeRange: timeRange == null ? unmatched : z.string().refine((value) => timeRange.toString() === value),
	});

	const schema = z.tuple([metaMatcher, ...fragments]).rest(unmatched);

	return (queryKey: QueryKey): boolean => schema.safeParse(queryKey).success;
}
